import {
  CircleCheckIcon,
  CircleHelpIcon,
  InfoIcon,
  XCircleIcon,
} from "lucide-react";

import { cn } from "@/lib/utils";
import { CallStructuredSummaryStatus } from "@/types";

// Shared by the cards, the highlight rows and the grouped rows so a status
// always reads the same way. INFO is grey: the call produced something and
// nobody is grading it. UNKNOWN renders nothing. The topic never came up,
// which is not the same as a no.
export const StevieStatusIcon = ({
  className,
  status,
}: {
  className?: string;
  status: CallStructuredSummaryStatus;
}) => {
  /* Render */
  const render = () => {
    const iconClassName = cn(
      "h-[18px] w-[18px] shrink-0 rounded-full",
      className,
    );

    if (status === CallStructuredSummaryStatus.YES) {
      return (
        <CircleCheckIcon className={cn(iconClassName, "text-green-600")} />
      );
    }
    if (status === CallStructuredSummaryStatus.MAYBE) {
      return <CircleHelpIcon className={cn(iconClassName, "text-amber-600")} />;
    }
    if (status === CallStructuredSummaryStatus.NO) {
      return <XCircleIcon className={cn(iconClassName, "text-red-600")} />;
    }
    if (status === CallStructuredSummaryStatus.INFO) {
      return <InfoIcon className={cn(iconClassName, "text-slate-400")} />;
    }
    return null;
  };

  return render();
};
